import React, { useEffect, useState } from "react";
import api from "../../../utils/api";
import "./AdminDashboardHome.css";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";

const AdminDashboardHome = () => {

  const [stats, setStats] = useState({
    users: 0,
    pendingUsers: 0,
    admissions: 0,
    scholarships: 0,
    gallery: 0,
    totalPolls: 0,
    livePolls: 0,
    endedPolls: 0,
    totalVotes: 0,
  });

  const [admissionTrend, setAdmissionTrend] = useState([]);
  const [recentActivities, setRecentActivities] = useState([]);

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {

      const { data } = await api.get("/admin/dashboard");

      setStats(data.stats || {});
      setAdmissionTrend(data.admissionTrend || []);
      setRecentActivities(data.activities || []);

    } catch (error) {
      console.error("Dashboard fetch error", error);
    }
  };

  return (
    <div className="admin-dashboard-home">

      <h1 className="dashboard-title">Admin Dashboard</h1>

      {/* ===== STATS ===== */}
      <div className="stats-grid">

        <div className="stat-card">
          <h3>Total Users</h3>
          <p>{stats.users}</p>
        </div>

        <div className="stat-card">
          <h3>Pending Requests</h3>
          <p>{stats.pendingUsers}</p>
        </div>

        <div className="stat-card">
          <h3>Admissions</h3>
          <p>{stats.admissions}</p>
        </div>

        <div className="stat-card">
          <h3>Scholarships</h3>
          <p>{stats.scholarships}</p>
        </div>

        <div className="stat-card">
          <h3>Gallery Images</h3>
          <p>{stats.gallery}</p>
        </div>

        <div className="stat-card poll-stat-card">
          <h3>🗳️ Total Polls</h3>
          <p>{stats.totalPolls}</p>
          <span className="stat-sub">🟢 {stats.livePolls} live &nbsp;|&nbsp; 🔴 {stats.endedPolls} ended</span>
        </div>

        <div className="stat-card poll-stat-card votes-card">
          <h3>📊 Total Votes Cast</h3>
          <p>{stats.totalVotes}</p>
          <span className="stat-sub">Across all polls</span>
        </div>

      </div>

      {/* ===== CHART ===== */}
      <div className="dashboard-chart">

        <h2>Admissions Trend</h2>

        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={admissionTrend}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#2f6627"
              strokeWidth={3}
            />
          </LineChart>
        </ResponsiveContainer>

      </div>

      {/* ===== LOWER SECTION ===== */}
      <div className="dashboard-lower">

        {/* Activities */}
        <div className="recent-activities">
          <h2>Recent Activities</h2>

          {recentActivities.length === 0 ? (
            <p>No recent activities</p>
          ) : (
            recentActivities.map((activity, index) => (
              <div key={index} className="activity-item">
                {activity.message}
                <span>{activity.time}</span>
              </div>
            ))
          )}

        </div>

        {/* System Health */}
        <div className="system-health">
          <h2>System Status</h2>

          <div className="health-item success">
            Server Running
          </div>

          <div className="health-item success">
            Database Connected
          </div>

          <div className="health-item success">
            Cloud Storage Active
          </div>

        </div>

      </div>

    </div>
  );
};

export default AdminDashboardHome;

